/*eslint-disable*/
import { ChakraProvider,
    Box,
    Flex,
    Image,
    useColorModeValue,
    Link,
    Text,
    Button,
    IconButton,
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    VStack, } from "@chakra-ui/react";
import {  ChevronDownIcon, HamburgerIcon } from "@chakra-ui/icons";
import React, {useState} from "react";
import logoImage from "assets/img/logo.png";
import { useHistory } from "react-router-dom";

export default function Header(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const history = useHistory();
  const routeSignup = () =>{ 
    let path = `/signup`; 
    history.push(path);
  }

  const routeLogin = () =>{ 
    let path = `/login`; 
    history.push(path);
  }

  const routeHome = () =>{ 
    let path = `/`; 
    history.push(path);
  }

  const routeCourses = () =>{ 
    let path = `/courses`; 
    history.push(path);
  }

  const routeWorksheets = () =>{ 
    let path = `/worksheets`; 
    history.push(path);
  }

  return (
    <Box px={4} as="header"
      bg={useColorModeValue('white', 'gray.800')}
      boxShadow={useColorModeValue(
        'sm',
        '0 4px 6px rgba(9, 17, 28, 0.9)'
      )}
      position="fixed"
      width="100%"
      zIndex="55"
      top="0"
      padding="10px 0">
        <Flex justify="space-between" align="center" maxW="1200px" mx="auto" padding={{ base: '0 1rem', lg: "0" }}>
            {/* Logo */}
            <Flex align="center" gap={4}>
              <Image
                  alt={'KidD Logo'}
                  fit={'cover'}
                  align={'center'}
                  w={'50px'}
                  h={'50px'}
                  src={logoImage}
                />
              <Text fontWeight={600} color={'grey.700'}>
                  Kid D School
              </Text>
              <Box display={{ base: "none", md: "flex" }} mx={4} height="5" borderLeft="1px" borderColor="teal.600" />
              {/* Navigation */}
              <Flex gap={4} display={{ base: "none", md: "flex" }}>
                <Link onClick={routeHome}>
                  <Button variant="ghost" colorScheme="teal">
                    หน้าหลัก
                  </Button>
                </Link>
                <Link onClick={routeCourses}>
                  <Button variant="ghost" colorScheme="teal">
                    ชุดข้อสอบออนไลน์
                  </Button>
                </Link>
                <Link onClick={routeWorksheets}>
                  <Button variant="ghost" colorScheme="teal">
                    ใบงาน
                  </Button>
                </Link>
              </Flex>
            </Flex>
            <Flex align="center" gap={4} display={{ base: "none", md: "flex" }}></Flex>
            {/* User Actions */}
            <Flex align="center" gap={4} display={{ base: "none", md: "flex" }}>
              <Link onClick={routeLogin}>
                  <Button variant="outline" colorScheme="teal">
                      เข้าสู่ระบบ
                  </Button>
              </Link>
              <Link onClick={routeSignup}>
                  <Button colorScheme="teal">สมัครสมาชิก</Button>
              </Link>
            </Flex>

            {/* Mobile Menu Button */}
            <IconButton
              display={{ base: "flex", md: "none" }}
              icon={<HamburgerIcon />}
              onClick={toggleMenu}
              aria-label="Open Menu"
            />
        </Flex>
        {/* Mobile Drawer Menu */}
        <Drawer isOpen={isOpen} placement="right" onClose={toggleMenu}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>เมนู</DrawerHeader>
            <DrawerBody>
              <VStack spacing={4} align="start">
                <Link onClick={routeHome}>
                  <Button variant="ghost" colorScheme="teal">
                    หน้าหลัก
                  </Button>
                </Link>
                <Link onClick={routeCourses}>
                  <Button variant="ghost" colorScheme="teal">
                    ชุดข้อสอบออนไลน์
                  </Button>
                </Link>
                <Link onClick={routeWorksheets}>
                  <Button variant="ghost" colorScheme="teal">
                    ใบงาน
                  </Button>
                </Link>
                <Link onClick={routeLogin}>
                    <Button variant="ghost" colorScheme="teal">
                        เข้าสู่ระบบ
                    </Button>
                </Link>
                <Link onClick={routeSignup}>
                    <Button variant="ghost" colorScheme="teal">
                      สมัครสมาชิก
                    </Button>
                </Link>
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
    </Box>
  );
}
